/* ============================================================
   glyde-product.js — interactions for the Glyde product page
   - FAQ accordion (one-open-at-a-time)
   - Sticky ATC visibility tied to hero scroll position
   - Bundle selector → updates hidden quantity OR swaps to a
     dedicated bundle product variant (data-glyde-bundle-variant)
   - Variant selectors → finds matching variant, updates price/ATC label,
     availability, hidden variant id, sticky bar
   - Gallery thumbnail switching
   - Announcement countdown
   No external libs. Safe to fail without breaking the cart form.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    // Once tema genelindeki tek bicimlendiriciyi dene: glyde-css-loader onu
    // Liquid"in kendi `money` ciktisindan turetip window"a koyuyor. Boylece
    // buradaki fiyatlar sayfanin geri kalaniyla ayni bicimde cikar.
    try {
      if (window.glydeMoney) return window.glydeMoney(cents);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, format || window.Shopify.money_format);
      }
    } catch (e) {}
    var v = (cents / 100).toFixed(2);
    return v + ' ₺';
  }

  /* ---------- FAQ accordion ---------- */
  function initFAQ() {
    $$('[data-glyde-faq]').forEach(function (faq) {
      $$('.pt-faq-q', faq).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.pt-faq-item');
          if (!item) return;
          var willOpen = !item.classList.contains('is-open');
          // close siblings
          $$('.pt-faq-item', faq).forEach(function (it) {
            it.classList.remove('is-open');
            var q = $('.pt-faq-q', it); if (q) q.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  /* ---------- Sticky ATC ---------- */
  function initStickyBar() {
    $$('[data-glyde-sticky]').forEach(function (bar) {
      var sel = bar.getAttribute('data-glyde-sticky-trigger') || '[data-glyde-hero]';
      var trigger = $(sel);
      var atc = $('[data-glyde-sticky-atc]', bar);
      var realAtc = $('[data-glyde-atc]');

      if (atc) {
        atc.addEventListener('click', function () {
          // Gercek sepete-ekle butonuna basiyoruz: form neyse onu gonderir,
          // secili paket ve adet aynen korunur. Eskiden bu buton sadece
          // yukari kaydirip odaklaniyordu — uzerinde "Sepete Ekle" yazan
          // bir buton icin yaniltici.
          if (realAtc && !realAtc.disabled) { realAtc.click(); return; }
          var hero = $('[data-glyde-hero]');
          if (hero && hero.scrollIntoView) hero.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      function update() {
        var show = false;
        if (realAtc) {
          // Sticky bar, gercek buton ekranda DEGILKEN gorunur. Boylece
          // sayfanin en basinda da bir satin alma butonu hep elinin altinda
          // olur (mobilde gercek buton ~1.7 ekran asagida kaliyordu),
          // ama satin alma kutusundayken iki buton ayni anda cikmaz.
          var r = realAtc.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          show = r.bottom < 60 || r.top > vh - 20;
        } else if (trigger) {
          show = trigger.getBoundingClientRect().bottom < 80;
        }
        bar.classList.toggle('is-show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* ---------- Gallery thumbnails ---------- */
  function initGallery() {
    $$('[data-glyde-gallery]').forEach(function (gallery) {
      var thumbs = $$('[data-glyde-thumb]', gallery);
      var slides = $$('[data-glyde-slide]', gallery);
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var idx = thumb.getAttribute('data-glyde-thumb');
          thumbs.forEach(function (t) {
            t.classList.toggle('is-on', t === thumb);
            t.setAttribute('aria-selected', t === thumb ? 'true' : 'false');
          });
          slides.forEach(function (s) {
            s.classList.toggle('is-on', s.getAttribute('data-glyde-slide') === idx);
          });
        });
      });
    });
  }

  /* ---------- Bundles ---------- */
  function initBundles(form) {
    var group = $('[data-glyde-bundles]', form);
    if (!group) return;
    var qtyInput = $('[data-glyde-quantity]', form);
    var idInput = $('[data-glyde-variant-id]', form);
    var defaultVariantId = idInput ? idInput.value : null;
    var atcPrice = $('[data-glyde-atc-price]', form);
    var defaultAtcPrice = atcPrice ? atcPrice.textContent : null;
    var buttons = $$('[data-glyde-bundle]', group);

    // Pick currently checked or first
    var initial = buttons.find(function (b) { return b.getAttribute('aria-checked') === 'true'; }) || buttons[0];
    if (initial) applyBundle(initial);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        applyBundle(btn);
      });
    });

    function applyBundle(btn) {
      buttons.forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      var vid = btn.getAttribute('data-glyde-bundle-variant');
      var q = parseInt(btn.getAttribute('data-glyde-bundle-qty') || '1', 10);
      if (vid && idInput) {
        // Dedicated bundle product variant: add 1 of that variant
        idInput.value = vid;
        if (qtyInput) qtyInput.value = 1;
      } else {
        // Plain quantity bundle of the default variant
        if (idInput && defaultVariantId) idInput.value = defaultVariantId;
        if (qtyInput && q > 0) qtyInput.value = q;
      }
      // Reflect the promised bundle price on the ATC button
      if (atcPrice) {
        var priceLabel = btn.getAttribute('data-glyde-bundle-price');
        atcPrice.textContent = priceLabel || defaultAtcPrice;
      }
    }
  }

  /* ---------- Variant selection ---------- */
  function initVariantPicker(form) {
    var dataEl = $('[data-glyde-variants]', form);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var optionRoots = $$('[data-glyde-option-index]', form);
    if (!optionRoots.length) return;

    function getSelectedValues() {
      return optionRoots.map(function (row) {
        var current = $('.pt-swatch.is-on, .pt-pill.is-on', row);
        if (current) return current.getAttribute('data-glyde-option-value');
        return null;
      });
    }

    function matchVariant(values) {
      return variants.find(function (v) {
        return values.every(function (val, i) {
          if (val == null) return true;
          return (v.options[i] || '') === val;
        });
      });
    }

    function syncCurrentText(idx, val) {
      var label = form.querySelector('[data-glyde-option-current="' + idx + '"]');
      if (label) label.textContent = val;
    }

    function updateUI(variant) {
      if (!variant) return;
      // hidden id
      var idInput = $('[data-glyde-variant-id]', form);
      if (idInput) idInput.value = variant.id;

      // price
      var price = $('[data-glyde-price]', form);
      var compare = $('[data-glyde-compare]', form);
      var save = $('[data-glyde-save]', form);
      if (price) price.textContent = formatMoney(variant.price);
      if (compare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compare.style.display = '';
          compare.textContent = formatMoney(variant.compare_at_price);
        } else {
          compare.style.display = 'none';
        }
      }
      if (save) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          save.style.display = '';
          var diff = variant.compare_at_price - variant.price;
          var pct = Math.round((diff / variant.compare_at_price) * 100);
          save.textContent = formatMoney(diff) + ' tasarruf (%' + pct + ')';
        } else {
          save.style.display = 'none';
        }
      }

      // ATC
      var atc = $('[data-glyde-atc]', form);
      var atcPrice = $('[data-glyde-atc-price]', form);
      var atcLabel = $('[data-glyde-atc-label]', form);
      if (atc) {
        atc.disabled = !variant.available;
        if (!variant.available && atcLabel) {
          atcLabel.textContent = 'Tükendi';
        } else {
          if (atcPrice) atcPrice.textContent = formatMoney(variant.price);
        }
      }

      // Sticky
      var stickyPrice = $('[data-glyde-sticky-price]');
      var stickyVariant = $('[data-glyde-sticky-variant]');
      if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price)
        + (variant.compare_at_price && variant.compare_at_price > variant.price
            ? ' <s>' + formatMoney(variant.compare_at_price) + '</s>'
            : '');
      if (stickyVariant) stickyVariant.textContent = (variant.title || '').replace(/Default Title/, '');
    }

    function bind(row) {
      var idx = parseInt(row.getAttribute('data-glyde-option-index'), 10);
      $$('.pt-swatch, .pt-pill', row).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-glyde-option-value');
          $$('.pt-swatch, .pt-pill', row).forEach(function (b) { b.classList.toggle('is-on', b === btn); });
          syncCurrentText(idx, val);
          var values = getSelectedValues();
          var match = matchVariant(values);
          updateUI(match);
        });
      });
    }
    optionRoots.forEach(bind);
  }

  /* ---------- Announcement countdown ---------- */
  function initCountdown() {
    $$('[data-glyde-countdown]').forEach(function (el) {
      var seconds = parseInt(el.getAttribute('data-glyde-countdown'), 10);
      if (!seconds || isNaN(seconds)) return;
      function tick() {
        if (seconds <= 0) { el.textContent = '00:00'; return; }
        seconds -= 1;
        var m = String(Math.floor(seconds / 60)).padStart(2, '0');
        var s = String(seconds % 60).padStart(2, '0');
        el.textContent = m + ':' + s;
      }
      setInterval(tick, 1000);
    });
  }

  /* ---------- Bootstrap ---------- */
  function init() {
    initFAQ();
    initGallery();
    initStickyBar();
    initCountdown();
    $$('[data-glyde-form]').forEach(function (form) {
      initBundles(form);
      initVariantPicker(form);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when sections are re-rendered in the theme editor
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', init);
  }
})();
